'use client';

import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <Auth0Provider
      domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN || ''}
      clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID || ''}
      authorizationParams={{
        audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE || '',
        redirect_uri: process.env.NEXT_PUBLIC_APP_URL + '/callback' || '',
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      cookieDomain={process.env.NEXT_PUBLIC_AUTH0_COOKIE_DOMAIN}
      useCookiesForTransactions={true}
    >
      {children}
    </Auth0Provider>
  );
}
